import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../../../styles/order-delivery-match-count.css';

let nextTooltipId = 0;

export default function OrderDeliveryMatchCount({ order }) {
  const [tooltipId] = useState(() => `delivery-match-tooltip-${++nextTooltipId}`);
  const count = order.matchingDeliveryOrderCount;
  // The API counts only ready orders and returns zero when this order is not ready.
  // List rows do not include the line stock statuses needed for a second local check.
  if (['SENT', 'RETURNED', 'CANCELLED'].includes(order.orderStatus?.databaseValue) || !(count >= 2)) return null;
  const label = `Готових до відправки замовлень з однаковими даними доставки: ${count}. Можна об’єднати за потреби.`;
  return <OverlayTrigger placement='top' delay={0} trigger={['hover', 'focus']}
    overlay={<Tooltip id={tooltipId}>{label}</Tooltip>}>
    <span className='order-delivery-match-count' tabIndex={0} aria-label={label} role='img'>
      <i className='bi bi-box-seam' aria-hidden='true' />
      <span aria-hidden='true'>{count}</span>
    </span>
  </OverlayTrigger>;
}
